import { type ErrorResponse, onError } from '@apollo/client/link/error';

type ErrorCallback = (error: ErrorResponse) => void;

const errorCallbacks = new Set<ErrorCallback>();

export const errorEmitterLink = onError(error => {
  for (const callback of errorCallbacks) {
    callback(error);
  }
});

export function onGraphQLError(callback: ErrorCallback): () => void {
  errorCallbacks.add(callback);

  return () => {
    errorCallbacks.delete(callback);
  };
}
